import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=aa4cec16&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=ts"
export * from "./Faqs.vue?vue&type=script&lang=ts"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=aa4cec16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4cec16",
  null
  
)

export default component.exports